import { useCallback, useState } from 'react';
import { type CreateBoardMode, useBoardsContext } from '../context-provider';
import { getBoardAssetTypeFromAssetGroup } from '../utils/get-board-asset-type-from-asset-group';

interface UseCreateBoardHandlerProps {
  mode?: CreateBoardMode;
  newBoardName?: string;
  onCreateBoardEnd?: () => void;
}

export const useCreateBoardHandler = ({
  newBoardName,
  mode = 'create_board_with_asset',
  onCreateBoardEnd,
}: UseCreateBoardHandlerProps) => {
  const { asset, createBoard } = useBoardsContext();
  const [isCreatingBoard, setIsCreatingBoard] = useState(false);

  const handleCreateBoard = useCallback(async () => {
    if (isCreatingBoard || !newBoardName) {
      return;
    }
    setIsCreatingBoard(true);

    if (mode === 'create_board_with_asset' && asset) {
      await createBoard({
        name: newBoardName,
        asset: {
          id: Number(asset?.data.id),
          type: getBoardAssetTypeFromAssetGroup(asset),
        },
      });
    } else if (mode === 'create_board_only') {
      await createBoard({
        name: newBoardName,
      });
    }
    setIsCreatingBoard(false);
    onCreateBoardEnd?.();
  }, [
    newBoardName,
    asset,
    createBoard,
    isCreatingBoard,
    mode,
    onCreateBoardEnd,
  ]);

  return {
    handleCreateBoard,
    isCreatingBoard,
  };
};
